__turbopack_context__.v({
  "root": "CircleLoading-module__72XsWG__root",
  "spin": "CircleLoading-module__72XsWG__spin",
});
